import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext } from 'react';
const AbParticipationsContext = createContext(undefined);
export function AbParticipationsProvider({ participations, children, }) {
    return (_jsx(AbParticipationsContext.Provider, { value: participations, children: children }));
}
export function useAbParticipations() {
    const context = useContext(AbParticipationsContext);
    if (!context) {
        throw new Error('useAbParticipations must be used within an AbParticipationsProvider');
    }
    return context;
}
